import { RouterContext } from '@okapi/router-react/dist/Provider';
import { useContext } from 'react';

export const useNavigate = () => {
  const router = useContext(RouterContext);
  return router.navigate;
};
